import { render, staticRenderFns } from "./EmailLogin.vue?vue&type=template&id=492a3960&scoped=true&"
import script from "./EmailLogin.vue?vue&type=script&lang=js&"
export * from "./EmailLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492a3960",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('492a3960')) {
      api.createRecord('492a3960', component.options)
    } else {
      api.reload('492a3960', component.options)
    }
    module.hot.accept("./EmailLogin.vue?vue&type=template&id=492a3960&scoped=true&", function () {
      api.rerender('492a3960', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/User/modes/EmailLogin.vue"
export default component.exports